import {
  SpreadsheetDocumentsData,
  parseSpreadsheetDocuments,
} from '../models/SpreadsheetDocument';
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';

/**
 * NVR 원격등록 템플릿 스프레드시트 API 클라이언트 (다중 문서).
 *
 * 문서 1개 = 구역 1개(NVR 1대에 올리는 .xls 1개). 사용자가 다루는 값은 IP 와 CH NAME
 * 두 열뿐이고, 나머지 열(Fixed/CH NUM/PORT/ID/PASSWORD/RTSP*)은 내보낼 때 고정값으로
 * 채운다(nvrTemplateExport.ts). 저장은 projects.nvr_template_spreadsheet JSON 컬럼.
 */

export const NVR_IP_COLUMN = 'IP';
export const NVR_CH_NAME_COLUMN = 'CH NAME';

export const DEFAULT_NVR_TEMPLATE_COLUMNS: ReadonlyArray<{ name: string; width: number }> = [
  { name: NVR_IP_COLUMN, width: 160 },
  { name: NVR_CH_NAME_COLUMN, width: 200 },
];

const NVR_TEMPLATE_DOC_NAME = '1구역';

interface SpreadsheetApiResponse {
  success: boolean;
  message: string;
  data?: unknown;
}

export class NvrTemplateSpreadsheetService {
  static async get(projectId: number): Promise<SpreadsheetDocumentsData> {
    const response = await apiClient.get<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.NVR_TEMPLATE_SPREADSHEET.GET(projectId),
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '스프레드시트 조회 실패');
    }
    return parseSpreadsheetDocuments(response.data.data, {
      defaultDocName: NVR_TEMPLATE_DOC_NAME,
      defaultColumns: DEFAULT_NVR_TEMPLATE_COLUMNS,
    });
  }

  static async update(projectId: number, data: SpreadsheetDocumentsData): Promise<void> {
    const response = await apiClient.put<SpreadsheetApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.NVR_TEMPLATE_SPREADSHEET.UPDATE(projectId),
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '스프레드시트 저장 실패');
    }
  }
}
